import { gql } from 'graphql-request'

export const M_SUBMIT_CANCELLATION_AUDIT = gql`
  mutation SubmitCancellationAudit($action: String!, $ipAddress: String, $fingerprint: String, $userAgent: String, $metadata: String) {
    submitCancellationAudit(action: $action, ipAddress: $ipAddress, fingerprint: $fingerprint, userAgent: $userAgent, metadata: $metadata) {
      ... on CancellationAuditResult {
        success
      }
      ... on MutationFailure {
        errors {
          message
        }
      }
    }
  }
`
